import './player-avatar.scss';

import Jazzicon, { jsNumberForAddress } from 'react-jazzicon';

interface PlayerAvatarProps {
  id: string;
  avatar?: string | null;
  color?: string | null;
  size?: number;
  level?: number;
}

export function PlayerAvatar({ id, avatar, color, size = 28, level }: PlayerAvatarProps) {
  const tier = level ? Math.min(Math.max(level, 1), 5) : undefined;

  return (
    <div
      className={`player-avatar${tier ? ' player-avatar--leveled' : ''}`}
      style={{ width: size, height: size }}
      data-level={tier}>
      <div className="player-avatar__img">
        {avatar ? (
          <img src={avatar} alt="" className="player-avatar__photo" />
        ) : (
          <Jazzicon diameter={size} seed={jsNumberForAddress(id)} />
        )}
      </div>
      {color && <div className="player-avatar__dot" style={{ background: color }} />}
    </div>
  );
}
